module.exports = __webpack_public_path__ + "static/media/hands_13.d01a8151.svg";